import { Badge, type BadgeColor } from '@clay-run/glaze/badge';
import { STATUS_LABELS, type AdRequestStatus } from '../types';

const STATUS_COLORS: Record<AdRequestStatus, BadgeColor> = {
  needs_review: 'yellow',
  changes_requested: 'blue',
  rejected: 'red',
  publishing: 'default',
  published: 'green',
};

export function RequestStatusBadge({ status }: { status: AdRequestStatus }) {
  return <Badge color={STATUS_COLORS[status]}>{STATUS_LABELS[status]}</Badge>;
}
